<template>
  <b-modal ref="modal" @ok="save">
    <div ref="content">
      <b-tabs @input="changeLanguage" v-if="!loading" :value="languages.indexOf(currentLanguage)">
        <b-tab v-for="lang in languages" :key="lang.code" :title="lang.text">
          <h3>ID: {{file.id}}</h3>
          <vue-dropzone
            :id="dropzoneId"
            ref="dropzone"
            :options="dropZoneOptions"
            :destroyDropzone="true"
            @vdropzone-sending="sending"
            class="my-3"
          ></vue-dropzone>
          <div class="form-group">
            <label for="file-name">Name</label>
            <input
              type="text"
              id="file-name"
              :value="currentFile.name"
              @input="currentFile.name = $event.target.value"
              class="form-control"
            >
          </div>
          <div class="form-group">
            <label for="file-description">Beschreibung</label>
            <textarea
              id="file-description"
              :value="currentFile.description"
              @input="currentFile.description = $event.target.value"
              class="form-control"
            ></textarea>
          </div>
          <div class="form-group">
            <label for="file-description">Quelle</label>
            <input
              type="text"
              id="file-source"
              :value="currentFile.source"
              @input="currentFile.source = $event.target.value"
              class="form-control"
            >
          </div>
          <small>Achtung, alle Angaben in allen Sprachen erfassen.</small>
        </b-tab>
      </b-tabs>
      <loading v-else></loading>
    </div>
  </b-modal>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export default {
  props: ["file", "type"],
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    const languages = [
      { text: "Deutsch", code: "de" },
      { text: "Französisch", code: "fr" },
      { text: "Englisch", code: "en" }
    ];
    return {
      languages,
      loading: false,
      currentFile: {
        name: this.file.name,
        description: this.file.description,
        source: this.file.source,
        urls: this.file.urls ? this.file.urls : ""
      },
      currentLanguage: languages.find(
        lang => lang.code === store.state.language
      )
    };
  },
  watch: {
    file(newFile) {
      const languageIndex = this.languages.findIndex(
        lang => lang.code === store.state.language
      );

      if (!this.$refs.dropzone[languageIndex]) return;

      this.$refs.dropzone[languageIndex].setOption(
        "url",
        this.getUploadUrl(this.languages[languageIndex].code)
      );
    }
  },
  computed: {
    dropZoneOptions() {
      return {
        thumbnailWidth: 150,
        maxFiles: 1,
        paramName: "edit_" + this.type + "_part[file]",
        addRemoveLinks: true,
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>Datei hochladen",
        previewTemplate: this.template(),
        url: this.getUploadUrl(this.currentLanguage.code)
      };
    },
    dropzoneId() {
      return "input_" + this.file.id;
    },
    url() {
      return this.currentFile.urls
        ? this.currentFile.urls.original
        : this.currentFile.url;
    }
  },
  async mounted() {
    this.$refs.content.addEventListener("click", this.delegateModalClickEvent);
  },
  beforeDestroy() {
    this.$refs.content.removeEventListener(
      "click",
      this.delegateModalClickEvent
    );
  },
  methods: {
    delegateModalClickEvent(e) {
      if (!e.target.closest(".dz-preview")) return;

      this.filePreviewClickHandler();
    },
    filePreviewClickHandler() {
      window.open(this.url, "_blank");
    },
    getUploadUrl(lang) {
      return (
        window.baseUrl +
        "/api/" +
        lang +
        "/content/" +
        this.file.id +
        "/edit_" +
        this.type +
        "_part"
      );
    },
    sending(file, xhr, formData) {
      formData.append(
        "edit_" + this.type + "_part[translation_name]",
        this.currentFile.name
      );
      formData.append(
        "edit_" + this.type + "_part[translation_description]",
        this.currentFile.description
      );
    },
    template() {
      return `<div class="dz-preview dz-file-preview">
                <div class="dz-move"></div>
                <div class="dz-image">
                    <img data-dz-thumbnail>
                </div>
                <div class="dz-details">
                    <div class="dz-filename"><span data-dz-name></span></div>
                </div>
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
                <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                <div class="dz-error-mark"><i class="fa fa-close"></i></div>
            </div>
            `;
    },
    async setLocalValues(file) {
      this.currentFile = { ...file };
      this.currentFile.urls = file.urls ? file.urls : "";

      await this.$nextTick();
      const languageIndex = this.languages.indexOf(this.currentLanguage);

      if (!this.$refs.dropzone.length) return;

      this.$refs.dropzone[languageIndex].removeAllFiles();
      this.$refs.dropzone[languageIndex].manuallyAddFile(
        {
          name: file.name,
          filedata: file
        },
        this.type === "image" ? `${file.urls.preview}?${uuidv4()}` : false
      );
    },
    async changeLanguage(idx) {
      const newLanguage = this.languages[idx];

      const langCode = newLanguage.code;

      this.loading = true;
      try {
        const loadFilePromise =
          langCode === store.state.language
            ? Promise.resolve({ data: { result: this.file } })
            : axios.get("/api/" + langCode + "/content/" + this.file.id);

        const [
          _,
          {
            data: { result }
          }
        ] = await Promise.all([this.save(), loadFilePromise]);

        this.currentLanguage = newLanguage;
        this.setLocalValues(result);
      } finally {
        this.loading = false;
      }
    },
    save() {
      let form = new FormData();
      form.set(
        "edit_" + this.type + "_part[translation_name]",
        this.currentFile.name || ""
      );
      form.set(
        "edit_" + this.type + "_part[translation_description]",
        this.currentFile.description || ""
      );
      form.set(
        "edit_" + this.type + "_part[translation_source]",
        this.currentFile.source || ""
      );
      store.commit("addSavingProcess");
      return axios
        .post(
          "/api/" +
            this.currentLanguage.code +
            "/content/" +
            this.file.id +
            "/edit_" +
            this.type +
            "_part",
          form
        )
        .then(result => {
          store.commit("finishSavingProcess");
          if (this.currentLanguage.code === store.state.language) {
            this.file.name = result.data.result.name;
            this.file.description = result.data.result.description;
            this.file.source = result.data.result.source;
            this.file.urls = result.data.result.urls;
          }
          this.setLocalValues(result.data.result);
          this.$emit("saved");
        });
    },
    show() {
      this.setLocalValues(this.file);
      this.currentLanguage = this.languages.find(
        lang => lang.code === store.state.language
      );
      this.$refs.modal.show();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Parts/Input/FileModal.vue